import React from "react";
import {
  useMessageContext,
  useChannelStateContext,
  useChatContext,
} from "stream-chat-react";
import logger from '../../utils/logger';

export default function ModerationActions() {
  const { message } = useMessageContext("ModerationActions");
  const { channel } = useChannelStateContext("ModerationActions");
  const { client } = useChatContext("ModerationActions");

  try {
    const targetUserId = message?.user?.id;
    const myUserId = client?.userID || client?.user?.id;
    if (!targetUserId || !myUserId) return null;
    if (targetUserId === myUserId) return null;

    // Determine moderator privileges
    const moderators = Array.isArray(channel?.state?.moderators)
      ? channel.state.moderators
      : [];
    const moderatorIds = moderators
      .map((m) => (typeof m === "string" ? m : m?.id || m?.user?.id))
      .filter(Boolean);

    const createdById =
      channel?.state?.channel?.created_by?.id || channel?.data?.created_by?.id;

    const memberRole =
      channel?.state?.members?.[myUserId]?.role ||
      channel?.state?.membership?.role ||
      null;

    const isModerator =
      moderatorIds.includes(myUserId) ||
      createdById === myUserId ||
      memberRole === "moderator" ||
      memberRole === "admin";

    if (!isModerator) return null;

    const mutes = Array.isArray(client?.user?.mutes) ? client.user.mutes : [];
    const isMuted =
      mutes.findIndex(
        (m) => (m?.target?.id || m?.id || m) === targetUserId
      ) !== -1;

    const handleToggleMute = async (e) => {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      try {
        if (isMuted) {
          await client.unmuteUser(targetUserId);
          // Immediately notify UI
          if (typeof window !== "undefined") {
            window.dispatchEvent(
              new CustomEvent("chat-mute-changed", {
                detail: { userId: targetUserId, muted: false },
              })
            );
          }
        } else {
          await client.muteUser(targetUserId);
          // Immediately notify UI
          if (typeof window !== "undefined") {
            window.dispatchEvent(
              new CustomEvent("chat-mute-changed", {
                detail: { userId: targetUserId, muted: true },
              })
            );
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        logger("error", "Failed to toggle mute", err);
      }
    };

    return (
      <button
        aria-selected="false"
        className="str-chat__message-actions-list-item str-chat__message-actions-list-item-button"
        role="option"
        onClick={handleToggleMute}
      >
        {isMuted ? "Unmute" : "Mute"}
      </button>
    );
  } catch (e) {
    return null;
  }
}


